import type {
  SearchResult,
  SearchResultAcceptor,
  SearchResultFobEvent,
  SearchResultFobProposition,
  SearchResultRace,
} from '../types'

export function isSearchResultRace(result: SearchResult): result is SearchResultRace {
  return (result as SearchResultRace).race !== undefined
}

export function isSearchResultAcceptor(result: SearchResult): result is SearchResultAcceptor {
  return (result as SearchResultAcceptor).acceptor !== undefined
}

export function isSearchResultFobEvent(result: SearchResult): result is SearchResultFobEvent {
  return (result as SearchResultFobEvent).fobEvent !== undefined
}

export function isSearchResultFobProposition(
  result: SearchResult
): result is SearchResultFobProposition {
  return (result as SearchResultFobProposition).fobProposition !== undefined
}
